<template>
<div>
  <label :for="placeHolder" v-show="includeLabel">{{placeHolder}}</label>
  <input 
    :id="placeHolder"
    v-model="fieldValue" 
    :type="type" 
    v-bind:class="[
      {'border-danger validation-invalid': hasErrorProp}, 
      {'border-success validation-valid': !hasErrorProp && hasChanged}, 
      inputClass
    ]" 
    :placeholder="placeHolder">
  <span v-show="hasErrorProp" class="fas fa-exclamation-circle bg-white input-info-icon text-danger"></span>
  <span v-show="!hasErrorProp && hasChanged" class="fas fa-check-circle bg-white input-info-icon text-success"></span>
  <div class="error-message text-left">{{ errorTextProp }}</div>
</div>
</template>

<script>
export default {
  props: {
            initialFieldValue: {
              type: String,
              default: ""
            },
            hasError: {
              type: Boolean,
              default: false
            },
            errorText: {
              type: String,
              default: ""
            },
            type: {
              type: String,
              default: "text"
            },
            placeHolder: {
              type: String,
              default: ""
            },
            additionalClass: {
              type: String,
              default: ""
            },
            includeLabel: {
              type: Boolean,
              default: false
            }
          },
  data: function() {
    return {
      fieldValue: '',
      inputClass:"form-control",
      hasChanged: false
    }
  },

  mounted: function() {
    if (this.additionalClass)
      this.inputClass= this.inputClass + " " + this.additionalClass;
    this.fieldValue = this.initialFieldValue;
    this.$nextTick(()=> this.hasChanged = false);
  },

  watch: {
    fieldValue: function(data) {
      this.hasChanged = true;
      this.$emit('valueChanged', data);
    }
  },

  computed: {
    hasErrorProp: function() {
      return this.hasError;
    },
    errorTextProp: function() {
      return this.errorText;
    },
  }
}
</script>

<style lang="css">
.input-info-icon {
  float: right;
  position: relative;
  top: -39px;
  right: -7px;
}

.validation-invalid, .validation-invalid:focus  {
  background-color: #fee;
}
</style>
